<template>
  <button class="Drop-Menu-Item" @click="toOpenForm">
    <div class="Drop-Menu-Item__svg-box">
      <svg class="default-icon" viewBox="0 0 16 16" fill="none">
        <path d="M12.9045 5.71241C13.4317 5.1852 13.4317 4.33043 12.9045 3.80322L12.1974 3.09611C11.6702 2.5689 10.8154 2.5689 10.2882 3.09611L4.36521 9.01909C4.23894 9.14536 4.13898 9.29543 4.07111 9.46061L2.66773 12.8761C2.54959 13.1636 2.83695 13.451 3.12449 13.3329L6.53999 11.9295C6.70516 11.8616 6.85524 11.7617 6.98151 11.6354L12.9045 5.71241Z" stroke="var(--gray-600)" stroke-width="1.3"></path>
        <rect x="9.1748" y="5.01562" width="1.3" height="2.51953" transform="rotate(-45 9.1748 5.01562)" fill="var(--gray-600)"></rect>
      </svg>
    </div>
    Редактировать
  </button>
</template>

<script setup>
  import { computed } from 'vue';
  import { Props } from './scripts/props.js';
  import { useStore } from 'vuex';
  //--------------------------------------------
  const store = useStore();
  const props = defineProps(Props());
  const emit = defineEmits(['close']);
  //--------------------------------------------
  const ID = props.commentId;
  //--------------------------------------------
  //Получить контекст объекта для комментариев
  const get_commentsCtx = computed(() => {
    if(props.commentsPlace === 'popup') return 'popupComments';
    else if(props.commentsPlace === 'page') return 'contentPageComments';
  })
  //--------------------------------------------
  //Открыть форму редактирования комментария
  const toOpenForm = async() => {
    store.commit('ContentSystem/Comments/setChildFormCommentId', { id: ID, isEdit: true, context: get_commentsCtx.value });
    sendEmitClose();
  }
  //Отправляем событие закрытие дропдауна
  const sendEmitClose = () => emit('close');
</script>

<style lang="scss">
  @import '../../../../styles/Drop-Menu-Item.scss';
</style>